import { ReactComponent as AnalyticsIcon } from '../../../assets/images/analytics.svg';
import { ReactComponent as BookingsIcon } from '../../../assets/images/bookings.svg';
import { ReactComponent as DashboardIcon } from '../../../assets/images/home.svg';
import { ReactComponent as OrganisationIcon } from '../../../assets/images/organisation.svg';
import { ReactComponent as UserIcon } from '../../../assets/images/user.svg';
import { ReactComponent as VehicleIcon } from '../../../assets/images/van.svg';
import { ReactComponent as HelpIcon } from '../../../assets/images/Help_Icon_WEB.svg';

const defaultSize = 'w-[30px] h-[30px]';

export const getMenuIcon = (icon: string) => {
  switch (icon) {
    case 'dashboard':
      return <DashboardIcon className={defaultSize} />;
    case 'bookings':
      return <BookingsIcon className={defaultSize} />;
    case 'vehicles':
      return <VehicleIcon className={defaultSize} />;
    case 'users':
      return <UserIcon className="w-[35px] h-[35px]" />;
    case 'analytics':
      return <AnalyticsIcon className="w-[26px] h-[26px]" />;
    case 'organisation':
      return <OrganisationIcon className={defaultSize} />;
    case 'help':
      return <HelpIcon className={defaultSize} />
    default:
      return;
  }
};

const dashboardSize = 'w-[50px] h-[50px]';
const dashboardIconSize = `${dashboardSize} sm:w-[30px] sm:h-[30px]`;

export const getMenuDashboardIcon = (icon: string) => {
  switch (icon) {
    case 'bookings':
      return <BookingsIcon className={dashboardIconSize} />;
    case 'vehicles':
      return <VehicleIcon className={dashboardIconSize} />;
    case 'users':
      return (
        <UserIcon className={`${dashboardSize} sm:w-[35px] sm:h-[35px]`} />
      );
    case 'analytics':
      return (
        <AnalyticsIcon className={`${dashboardSize} sm:w-[26px] sm:h-[26px]`} />
      );
    default:
      return;
  }
};
